var loadingbar = {
    started: false,
    start: function () {
		loader.start();
        this.started = true;
    },
	search:function(){
		loader.start('search');
        this.started = true;
	},
    stop: function () {
		loader.stop();
        this.started = false;
    },
    toggle: function () {
        if (this.started === true) {
            this.stop();
        } else {
            this.start();
        }
    }
}